import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noReviewersMessage: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.reviewers-cell.no-reviewers-message',
		defaultMessage: 'No reviewers',
		description:
			'Displayed inside a table cell on a row representing a Pull Request, when that Pull Request has no reviewers assigned.',
	},
	unknownUser: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.reviewers-cell.unknown-user',
		defaultMessage: 'Unknown user',
		description:
			'Displayed as a tooltip on an avatar, or inside a popup when the name of the user being represented by the avatar / popup is not known',
	},
});
